import React, { useState } from 'react'
import { Button, Icon, Modal, Header, ModalHeader } from 'semantic-ui-react'
import DeleteModal from '../modalComponent/deleteFile'
import EditModal from '../modalComponent/EditModal'
import ReadAxios from '../axiosComponent/readAxios'
import { id } from 'date-fns/locale'
import { setISODay } from 'date-fns'
import VehicleDetailsTable from './vehicleDetailsTable'

function ActionButton(props) {
    const [openBox, setopenBox] = useState(false)
    const [success, setsuccess] = useState(false)
    const [openEditBox, setopenEditBox] = useState(false)
    // const [success, setsuccess] = useState(false)

    console.log(props)

    let handleOpenDelete = () => {
        setopenBox(true)
    }

    let handleClose = () => {
        setopenBox(false)
    }
    let handleDelete = () => {
        setsuccess(true)

    }

    let handleOpenEdit = () => {
        console.log("in edit")
        console.log("edit props :", props);
        setopenEditBox(true)
        let id = props.data.id

    }

    let handleEditClose = () => {
        setopenEditBox(false)
    }

    return (
        <>
            <center><Button onClick={handleOpenEdit} basic size="mini" type="button" icon> <Icon name="file alternate" color="blue" /></Button></center>
            <Modal
                open={openEditBox}
                onClose={handleEditClose}
                size="large"
            >
                <ModalHeader><h5>View Vehicle Details</h5> </ModalHeader>

                <VehicleDetailsTable id={props.data.id} />

                <Modal.Actions>
                    <Button onClick={handleEditClose} size="mini" color="blue">Close</Button>
                </Modal.Actions>
            </Modal>
        </>
    )
}

export default ActionButton
